import api from "@/plugins/axios";

import { useGlobalStore } from "@/stores";

const actions = () => ({
  getChangedKeys(prev, current) {
    const changedKeys = [];

    for (const key in current) {
      // console.log(
      //   `key: ${key} ${JSON.stringify(
      //     prev[key]
      //   )}    |    prev: ${JSON.stringify(
      //     prev[key].hash
      //   )}    | current: ${JSON.stringify(current[key].hash)}`
      // );
      if (prev[key].hash !== current[key].hash) {
        //changedKeys.push(key);
        this.handleChangeForKey(prev[key].name, current[key].hash);
        this.prevListHashes[key].hash = this.listHashes[key].hash;
      }
    }

    return changedKeys;
  },

  handleChangeForKey(key, newHash) {
    this.shouldUpdate[key] = true;
  },
  async fetchListHashes() {
    const response = await api.get("/api/list/list-hashes");
    if (
      this.prevListHashes.length == 0 ||
      this.prevListHashes.length != response.data.length
    ) {
      this.prevListHashes = response.data;
    }
    this.listHashes = response.data;
    const changes = this.getChangedKeys(this.prevListHashes, this.listHashes);

    //console.log("Changes detected: " + JSON.stringify(changes));
  },

  async fetchCountries() {
    if (this.countries.length > 0 && !this.shouldUpdate["countries"]) {
      return this.countries;
    }
    const response = await api.get("/api/list/countries");
    this.countries = response.data;
    this.shouldUpdate["countries"] = false;
  },

  async fetchRefer() {
    if (this.refer.length > 0 && !this.shouldUpdate["referSources"]) {
      return this.refer;
    }
    const response = await api.get("/api/list/refer-source");
    this.refer = response.data;
    this.shouldUpdate["countries"] = false;
  },

  async fetchUsers() {
    const response = await api.get("/api/list/users");
    this.users = response.data;
  },

  async fetchBranches() {
    if (this.branches.length > 0 && !this.shouldUpdate["branches"]) {
      return this.branches;
    }
    const response = await api.get("/api/list/branches");
    this.branches = response.data;
    this.shouldUpdate["branches"] = false;
  },

  async fetchPrograms() {
    // if (this.programs.length > 0) {
    //   return this.programs;
    // }
    const response = await api.get("/api/list/programs");
    this.programs = response.data;
  },

  async fetchOrganizations() {
    if (this.organizations.length > 0 && !this.shouldUpdate["organizations"]) {
      return this.organizations;
    }
    const response = await api.get("/api/list/organizations");
    this.organizations = response.data;
    this.shouldUpdate["organizations"] = false;
  },

  async fetchServices() {
    if (this.services.length > 0 && !this.shouldUpdate["services"]) {
      return this.services;
    }
    const response = await api.get("/api/list/services");
    this.services = response.data;
    this.shouldUpdate["services"] = false;
  },

  async fetchJobPositions(payload) {
    let response;
    if (payload != null) {
      response = await api.get("/api/list/job-positions", {
        params: payload,
      });
    } else {
      response = await api.get("/api/list/job-positions");
    }
    this.jobPositions = response.data;
  },

  async fetchLanguages() {
    const response = await api.get("/api/list/languages");
    this.languages = response.data;
  },

  async fetchEducationSections() {
    if (
      this.educationSections.length > 0 &&
      !this.shouldUpdate["educationSections"]
    ) {
      return this.educationSections;
    }
    const response = await api.get("/api/list/education-sections");
    this.educationSections = response.data;
    this.shouldUpdate["educationSections"] = false;
  },

  async fetchProfessionalFields() {
    if (
      this.professionalFields.length > 0 &&
      !this.shouldUpdate["professionalFields"]
    ) {
      return this.professionalFields;
    }
    const response = await api.get("/api/list/professional-fields");
    this.professionalFields = response.data;
    this.shouldUpdate["professionalFields"] = false;
  },

  async fetchBusinessSectors() {
    if (
      this.businessSectors.length > 0 &&
      !this.shouldUpdate["businessSectors"]
    ) {
      return this.businessSectors;
    }
    const response = await api.get("/api/list/business-sectors");
    this.businessSectors = response.data;
    this.shouldUpdate["businessSectors"] = false;
  },

  async fetchComputerSkills() {
    if (
      this.computerSkills.length > 0 &&
      !this.shouldUpdate["computerSkills"]
    ) {
      return this.computerSkills;
    }
    const response = await api.get("/api/list/computer-skills");
    this.computerSkills = response.data;
    this.shouldUpdate["computerSkills"] = false;
  },

  async fetchSectors() {
    if (this.sectors.length > 0 && !this.shouldUpdate["sectors"]) {
      return this.sectors;
    }
    const response = await api.get("/api/list/sectors");
    this.sectors = response.data;
    this.shouldUpdate["sectors"] = false;
  },

  async fetchSoftSkillTrainings() {
    if (
      this.softSkillTrainings.length > 0 &&
      !this.shouldUpdate["softSkillTrainings"]
    ) {
      return this.softSkillTrainings;
    }
    const response = await api.get("/api/list/soft-skill-trainings");
    this.softSkillTrainings = response.data;
    this.shouldUpdate["softSkillTrainings"] = false;
  },

  async fetchIscoCodes() {
    if (this.iscoCodes.length > 0 && !this.shouldUpdate["iscoCodes"]) {
      return this.iscoCodes;
    }
    const response = await api.get("/api/list/isco-codes");
    this.iscoCodes = response.data;
    this.shouldUpdate["iscoCodes"] = false;
  },

  async fetchProfessions() {
    const response = await api.get("/api/list/professions");
    this.professions = response.data;
    this.shouldUpdate["professions"] = false;
  },

  async fetchAcademyOfficers(active) {
    var params = {};
    if (active !== undefined && active !== null) {
      params.active = active;
    }
    const response = await api.get("/api/list/academy-officers", { params });
    this.academyOfficers = response.data;
  },

  async fetchEmployabilityOfficers(active) {
    var params = {};
    if (active !== undefined && active !== null) {
      params.active = active;
    }
    const response = await api.get("/api/list/employability-officers", {
      params,
    });
    this.employabilityOfficers = response.data;
  },

  async fetchCourses() {
    const response = await api.get("/api/list/courses");
    this.courses = response.data;
  },

  async fetchThematicAreas() {
    if (this.thematicAreas.length > 0 && !this.shouldUpdate["thematicAreas"]) {
      return this.thematicAreas;
    }
    const response = await api.get("/api/list/courses/thematic-areas");
    this.thematicAreas = response.data;
    this.shouldUpdate["thematicAreas"] = false;
  },

  async fetchCourseSections() {
    if (
      this.courseSections.length > 0 &&
      !this.shouldUpdate["courseSections"]
    ) {
      return this.courseSections;
    }
    const response = await api.get("/api/list/courses/sections");
    this.courseSections = response.data;
    this.shouldUpdate["courseSections"] = false;
  },

  async fetchCourseTypes() {
    if (this.courseTypes.length > 0 && !this.shouldUpdate["courseTypes"]) {
      return this.courseTypes;
    }
    const response = await api.get("/api/list/courses/types");
    this.courseTypes = response.data;
    this.shouldUpdate["courseTypes"] = false;
  },

  async fetchBeneficiaries(payload) {
    const response = await api.get("/api/list/beneficiaries", {
      params: payload,
    });
    return response.data;
  },

  async fetchBeneficiaryIntakes(payload) {
    const response = await api.get("/api/list/beneficiary-intakes", {
      params: payload,
    });
    return response.data;
  },

  async fetchBeneficiariesPaginated(payload) {
    const response = await api.get("/api/list/beneficiaries/paginated", {
      params: payload,
    });
    return response.data;
  },

  async fetchCommunicationResponsibles(active) {
    var params = {};
    if (active !== undefined && active !== null) {
      params.active = active;
    }
    const response = await api.get("/api/list/communication-responsibles", {
      params,
    });
    this.communicationResponsibles = response.data;
  },

  async fetchCompanies() {
    const response = await api.get("/api/list/companies");
    this.companies = response.data;
  },

  async fetchEmplServices() {
    if (this.emplServices.length > 0 && !this.shouldUpdate["emplServices"]) {
      return this.emplServices;
    }
    const response = await api.get("/api/list/empl-services");
    this.emplServices = response.data;
    this.shouldUpdate["emplServices"] = false;
  },

  async fetchEmplFields() {
    // if (this.employmentFields.length > 0) {
    //   return this.employmentFields;
    // }
    const response = await api.get("/api/list/empl-fields");
    this.employmentFields = response.data;
  },

  async fetchEmployabilities() {
    const response = await api.get("/api/list/employabilities");
    this.employabilities = response.data;
  },

  async fetchLivelihoods() {
    const response = await api.get("/api/list/livelihoods");
    this.livelihoods = response.data;
  },

  async fetchTaOfficers(active) {
    var params = {};
    if (active !== undefined && active !== null) {
      params.active = active;
    }
    const response = await api.get("/api/list/ta-officers", { params });
    this.taOfficers = response.data;
  },

  async fetchCompaniesSectors() {
    if (this.companiesSectors.length > 0) {
      return this.companiesSectors;
    }
    const response = await api.get("/api/list/companies-sectors");
    this.companiesSectors = response.data;
  },

  async fetchAdminLocations() {
    const response = await api.get("/api/list/admin-locations");
    this.adminLocations = response.data;
  },

  async fetchAdminLocationCities(adminId) {
    const response = await api.get("/api/list/admin-cities", {
      params: { adminId: adminId },
    });
    this.adminLocationCities = response.data;
  },

  async fetchGreekCities() {
    if (this.greekCities.length > 0) {
      return this.greekCities;
    }
    const response = await api.get("/api/list/locations/cities");
    this.greekCities = response.data;
  },

  async createOrganization(payload) {
    await api.post("/api/list/create/organizations", payload);
    this.createSuccessMessage();
  },

  async updateOrganization(payload) {
    await api.post("/api/list/edit/organizations", payload);
    this.updateSuccessMessage();
  },

  async deleteOrganization(payload) {
    await api.post("/api/list/delete/organizations", payload);
    this.deleteSuccessMessage();
  },

  async createCountry(payload) {
    await api.post("/api/list/create/countries", payload);
    this.createSuccessMessage();
  },

  async updateCountry(payload) {
    await api.post("/api/list/edit/coutries", payload);
    this.updateSuccessMessage();
  },

  async deleteCountry(payload) {
    await api.post("/api/list/delete/countries", payload);
    this.deleteSuccessMessage();
  },

  async createReferSourced(payload) {
    await api.post("/api/list/create/refer-sources", payload);
    this.createSuccessMessage();
  },

  async updateReferSource(payload) {
    await api.post("/api/list/edit/refer-sources", payload);
    this.updateSuccessMessage();
  },

  async deleteReferSource(payload) {
    await api.post("/api/list/delete/refer-sources", payload);
    this.deleteSuccessMessage();
  },

  async createBranch(payload) {
    await api.post("/api/list/create/branches", payload);
    this.createSuccessMessage();
  },

  async updateBranch(payload) {
    await api.post("/api/list/edit/branches", payload);
    this.updateSuccessMessage();
  },

  async deleteBranch(payload) {
    await api.post("/api/list/delete/branches", payload);
    this.deleteSuccessMessage();
  },

  async createService(payload) {
    await api.post("/api/list/create/services", payload);
    this.createSuccessMessage();
  },

  async updateServicd(payload) {
    await api.post("/api/list/edit/services", payload);
    this.updateSuccessMessage();
  },

  async deleteService(payload) {
    await api.post("/api/list/delete/services", payload);
    this.deleteSuccessMessage();
  },

  async createEducationSection(payload) {
    await api.post("/api/list/create/education-sections", payload);
    this.createSuccessMessage();
  },

  async updateEducationSection(payload) {
    await api.post("/api/list/edit/education-sections", payload);
    this.updateSuccessMessage();
  },

  async deleteEducationSection(payload) {
    await api.post("/api/list/delete/education-sections", payload);
    this.deleteSuccessMessage();
  },

  async createProfessionalField(payload) {
    await api.post("/api/list/create/professional-fields", payload);
    this.createSuccessMessage();
  },

  async updateProfessionalField(payload) {
    await api.post("/api/list/edit/professional-fields", payload);
    this.updateSuccessMessage();
  },

  async deleteProfessionalField(payload) {
    await api.post("/api/list/delete/professional-fields", payload);
    this.deleteSuccessMessage();
  },

  async createBusinessSector(payload) {
    await api.post("/api/list/create/business-sectors", payload);
    this.createSuccessMessage();
  },

  async updateBusinessSector(payload) {
    await api.post("/api/list/edit/business-sectors", payload);
    this.updateSuccessMessage();
  },

  async deleteBusinessSector(payload) {
    await api.post("/api/list/delete/business-sectors", payload);
    this.deleteSuccessMessage();
  },

  async createComputerSkill(payload) {
    await api.post("/api/list/create/computer-skills", payload);
    this.createSuccessMessage();
  },

  async updateComputerSkill(payload) {
    await api.post("/api/list/edit/computer-skills", payload);
    this.updateSuccessMessage();
  },

  async deleteComputerSkill(payload) {
    await api.post("/api/list/delete/computer-skills", payload);
    this.deleteSuccessMessage();
  },

  async createSector(payload) {
    await api.post("/api/list/create/sectors", payload);
    this.createSuccessMessage();
  },

  async updateSector(payload) {
    await api.post("/api/list/edit/sectors", payload);
    this.updateSuccessMessage();
  },

  async deleteSector(payload) {
    await api.post("/api/list/delete/sectors", payload);
    this.deleteSuccessMessage();
  },

  async createSoftSkillTraining(payload) {
    await api.post("/api/list/create/soft-skill-trainings", payload);
    this.createSuccessMessage();
  },

  async updateSoftSkillTraining(payload) {
    await api.post("/api/list/edit/soft-skill-trainings", payload);
    this.updateSuccessMessage();
  },

  async deleteSoftSkillTraining(payload) {
    await api.post("/api/list/delete/soft-skill-trainings", payload);
    this.deleteSuccessMessage();
  },

  async createThematicArea(payload) {
    await api.post("/api/list/create/thematic-areas", payload);
    this.createSuccessMessage();
  },

  async updateThematicArea(payload) {
    await api.post("/api/list/edit/thematic-areas", payload);
    this.updateSuccessMessage();
  },

  async deleteThematicArea(payload) {
    await api.post("/api/list/delete/thematic-areas", payload);
    this.deleteSuccessMessage();
  },

  async createCourseSection(payload) {
    await api.post("/api/list/create/course-sections", payload);
    this.createSuccessMessage();
  },

  async updateCourseSection(payload) {
    await api.post("/api/list/edit/course-sections", payload);
    this.updateSuccessMessage();
  },

  async deleteCourseSection(payload) {
    await api.post("/api/list/delete/course-sections", payload);
    this.deleteSuccessMessage();
  },

  async createCourseType(payload) {
    await api.post("/api/list/create/course-types", payload);
    this.createSuccessMessage();
  },

  async updateCourseType(payload) {
    await api.post("/api/list/edit/course-types", payload);
    this.updateSuccessMessage();
  },

  async deleteCourseType(payload) {
    await api.post("/api/list/delete/course-types", payload);
    this.deleteSuccessMessage();
  },

  async createEmplService(payload) {
    await api.post("/api/list/create/empl-services", payload);
    this.createSuccessMessage();
  },

  async updateEmplService(payload) {
    await api.post("/api/list/edit/empl-services", payload);
    this.updateSuccessMessage();
  },

  async deleteEmplService(payload) {
    await api.post("/api/list/delete/empl-services", payload);
    this.deleteSuccessMessage();
  },

  async createProfession(payload) {
    await api.post("/api/list/create/professions", payload);
    this.createSuccessMessage();
  },

  async updateProfession(payload) {
    await api.post("/api/list/edit/professions", payload);
    this.updateSuccessMessage();
  },

  async deleteProfession(payload) {
    await api.post("/api/list/delete/professions", payload);
    this.deleteSuccessMessage();
  },

  async searchProfessions(payload) {
    const response = await api.get("/api/list/search-professions", {
      params: payload,
    });
    return response.data;
  },

  createSuccessMessage() {
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "List item has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });
  },

  updateSuccessMessage() {
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "List item has been successfully updated",
      timeout: 3000,
      type: "success",
      position: "top",
    });
  },

  deleteSuccessMessage() {
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "List item has been successfully deleted",
      timeout: 3000,
      type: "success",
      position: "top",
    });
  },
});

export default actions;
